// 6th Run
import React, { useState } from 'react';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Web3 from 'web3';

      const contractABI = [{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"previousAdmin","type":"address"},{"indexed":false,"internalType":"address","name":"newAdmin","type":"address"}],"name":"AdminChanged","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"},{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":false,"internalType":"bool","name":"approved","type":"bool"}],"name":"ApprovalForAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"beacon","type":"address"}],"name":"BeaconUpgraded","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"id","type":"uint256"},{"indexed":false,"internalType":"address","name":"controller","type":"address"}],"name":"Created","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint8","name":"version","type":"uint8"}],"name":"Initialized","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256[]","name":"ids","type":"uint256[]"},{"indexed":false,"internalType":"uint256[]","name":"values","type":"uint256[]"}],"name":"TransferBatch","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"id","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"TransferSingle","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"string","name":"value","type":"string"},{"indexed":true,"internalType":"uint256","name":"id","type":"uint256"}],"name":"URI","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"implementation","type":"address"}],"name":"Upgraded","type":"event"},{"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"uint256","name":"id","type":"uint256"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address[]","name":"accounts","type":"address[]"},{"internalType":"uint256[]","name":"ids","type":"uint256[]"}],"name":"balanceOfBatch","outputs":[{"internalType":"uint256[]","name":"","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"id","type":"uint256"},{"internalType":"uint256","name":"quantity","type":"uint256"}],"name":"burn","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"uint256[]","name":"ids","type":"uint256[]"},{"internalType":"uint256[]","name":"values","type":"uint256[]"}],"name":"burnBatch","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"enum Roles.Role[]","name":"grants","type":"uint8[]"},{"internalType":"enum Roles.Role[]","name":"disables","type":"uint8[]"}],"name":"create","outputs":[{"internalType":"uint256","name":"id","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"maintainer","type":"address"},{"internalType":"enum Roles.Role[]","name":"grants","type":"uint8[]"},{"internalType":"enum Roles.Role[]","name":"disables","type":"uint8[]"}],"name":"create","outputs":[{"internalType":"uint256","name":"id","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"create","outputs":[{"internalType":"uint256","name":"id","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"enum Roles.Role","name":"toDisable","type":"uint8"},{"internalType":"uint256","name":"disablingIndex","type":"uint256"}],"name":"disableRole","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"id","type":"uint256"}],"name":"exists","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"enum Roles.Role","name":"role","type":"uint8"},{"internalType":"address","name":"user","type":"address"},{"internalType":"uint256","name":"index","type":"uint256"}],"name":"gateToken","outputs":[{"internalType":"uint256","name":"id","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"id","type":"uint256"}],"name":"getMax","outputs":[{"internalType":"int64","name":"max","type":"int64"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"id","type":"uint256"}],"name":"getPerUserMax","outputs":[{"internalType":"int256","name":"max","type":"int256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"enum Roles.Role","name":"role","type":"uint8"},{"internalType":"address","name":"user","type":"address"},{"internalType":"uint256","name":"id","type":"uint256"},{"internalType":"bool","name":"singleUse","type":"bool"}],"name":"grantRole","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"enum Roles.Role","name":"role","type":"uint8"},{"internalType":"address","name":"user","type":"address"}],"name":"grantRole","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"enum Roles.Role","name":"role","type":"uint8"},{"internalType":"address","name":"user","type":"address"},{"internalType":"bool","name":"singleUse","type":"bool"}],"name":"grantRole","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"enum Roles.Role","name":"role","type":"uint8"},{"internalType":"address","name":"user","type":"address"},{"internalType":"uint256","name":"id","type":"uint256"}],"name":"grantRole","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"enum Roles.Role","name":"role","type":"uint8"}],"name":"hasRole","outputs":[{"internalType":"bool","name":"has","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"enum Roles.Role","name":"role","type":"uint8"},{"internalType":"address","name":"user","type":"address"},{"internalType":"uint256","name":"id","type":"uint256"}],"name":"hasRole","outputs":[{"internalType":"bool","name":"has","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"enum Roles.Role","name":"role","type":"uint8"},{"internalType":"uint256","name":"id","type":"uint256"}],"name":"hasRole","outputs":[{"internalType":"bool","name":"has","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"enum Roles.Role","name":"role","type":"uint8"},{"internalType":"address","name":"user","type":"address"}],"name":"hasRole","outputs":[{"internalType":"bool","name":"has","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"string","name":"_name","type":"string"},{"internalType":"string","name":"_symbol","type":"string"}],"name":"initialize","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"intValues","outputs":[{"internalType":"int256","name":"","type":"int256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"address","name":"operator","type":"address"}],"name":"isApprovedForAll","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"isSuper","outputs":[{"internalType":"bool","name":"superuser","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"user","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"isSuper","outputs":[{"internalType":"bool","name":"superuser","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"user","type":"address"}],"name":"isSuper","outputs":[{"internalType":"bool","name":"superuser","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"isSuper","outputs":[{"internalType":"bool","name":"superuser","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address[]","name":"to","type":"address[]"},{"internalType":"uint256","name":"id","type":"uint256"},{"internalType":"bytes","name":"data","type":"bytes"}],"name":"mint","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"id","type":"uint256"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"bytes","name":"data","type":"bytes"}],"name":"mint","outputs":[{"internalType":"bool","name":"minted","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"proxiableUUID","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"enum Roles.Role","name":"role","type":"uint8"}],"name":"roleToken","outputs":[{"internalType":"uint256","name":"id","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"enum Roles.Role","name":"role","type":"uint8"},{"internalType":"uint256","name":"index","type":"uint256"}],"name":"roleToken","outputs":[{"internalType":"uint256","name":"id","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256[]","name":"ids","type":"uint256[]"},{"internalType":"uint256[]","name":"amounts","type":"uint256[]"},{"internalType":"bytes","name":"data","type":"bytes"}],"name":"safeBatchTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"id","type":"uint256"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"bytes","name":"data","type":"bytes"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"operator","type":"address"},{"internalType":"bool","name":"approved","type":"bool"}],"name":"setApprovalForAll","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"_name","type":"string"},{"internalType":"string","name":"_symbol","type":"string"}],"name":"setDescription","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"id","type":"uint256"},{"internalType":"int64","name":"max","type":"int64"}],"name":"setMax","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"id","type":"uint256"},{"internalType":"int64","name":"max","type":"int64"}],"name":"setPerUserMax","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"id","type":"uint256"},{"internalType":"string","name":"newURI","type":"string"}],"name":"setURI","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenByIndex","outputs":[{"internalType":"uint256","name":"id","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"id","type":"uint256"}],"name":"tokenIndex","outputs":[{"internalType":"uint256","name":"index","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenOfOwnerByIndex","outputs":[{"internalType":"uint256","name":"id","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"id","type":"uint256"}],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"typeSupply","outputs":[{"internalType":"uint256","name":"count","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"uintValues","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"newImplementation","type":"address"}],"name":"upgradeTo","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newImplementation","type":"address"},{"internalType":"bytes","name":"data","type":"bytes"}],"name":"upgradeToAndCall","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"uint256","name":"id","type":"uint256"}],"name":"uri","outputs":[{"internalType":"string","name":"metadata","type":"string"}],"stateMutability":"view","type":"function"}];

const contractAddress = '0x3059b722579949459a7a778771ec5e2e990392a1';

function SmartContractUI() {
  const [contractSymbol, setContractSymbol] = useState('');
  const [contractName, setContractName] = useState('');
  const [typeSupply, setTypeSupply] = useState('');
  const [contractOwner, setContractOwner] = useState('');
  const [balanceOfResult, setBalanceOfResult] = useState(null);
  const [balanceOfAccount, setBalanceOfAccount] = useState('');
  const [balanceOfId, setBalanceOfId] = useState('');
  const [isSuperResult, setIsSuperResult] = useState(null);
  const [isSuperUser, setIsSuperUser] = useState('');
  const [isSuperTokenId, setIsSuperTokenId] = useState('');
  const [totalSupply, setTotalSupply] = useState('');
  const [tokenURI, setTokenURI] = useState('');



  const [tokenExists, setTokenExists] = useState('');

  const [isConnectedToPolygon, setIsConnectedToPolygon] = useState(false);

  const connectToMetamask = async () => {
    if (window.ethereum) {
      try {
        await window.ethereum.request({ method: 'eth_requestAccounts' });
        const networkId = await window.ethereum.request({ method: 'net_version' });
        if (networkId === '137') {
          setIsConnectedToPolygon(true);
        } else {
          setIsConnectedToPolygon(false);
        }
      } catch (error) {
        console.error('Error connecting to MetaMask:', error);
        setIsConnectedToPolygon(false);
      }
    }
  };

  const callSymbolFunction = async () => {
    if (window.ethereum) {
      try {
        const web3 = new Web3(window.ethereum);
        const contract = new web3.eth.Contract(contractABI, contractAddress);
        const symbol = await contract.methods.symbol().call();
        setContractSymbol(symbol);
        console.log('Symbol:', symbol);
      } catch (error) {
        console.error('Error calling symbol function:', error);
      }
    }
  };

  const callNameFunction = async () => {
    if (window.ethereum) {
      try {
        const web3 = new Web3(window.ethereum);
        const contract = new web3.eth.Contract(contractABI, contractAddress);
        const name = await contract.methods.name().call();
        setContractName(name);
        console.log('Name:', name);
      } catch (error) {
        console.error('Error calling name function:', error);
      }
    }
  };



  const callTypeSupplyFunction = async () => {
    if (window.ethereum) {
      try {
        const web3 = new Web3(window.ethereum);
        const contract = new web3.eth.Contract(contractABI, contractAddress);
        const typeSupply = await contract.methods.typeSupply().call();
        setTypeSupply(typeSupply);
        console.log('Total Token Type Supply :', typeSupply);
      } catch (error) {
        console.error('Error calling type function:', error);
      }
    }
  };


  const callOwnerFunction = async () => {
    if (window.ethereum) {
      try {
        const web3 = new Web3(window.ethereum);
        const contract = new web3.eth.Contract(contractABI, contractAddress);
        const owner = await contract.methods.owner().call();
        setContractOwner(owner);
        console.log('Owner:', owner);
      } catch (error) {
        console.error('Error calling owner function:', error);
      }
    }
  };

  const callIsSuperFunction = async () => {
    if (window.ethereum) {
      try {
        const web3 = new Web3(window.ethereum);
        const contract = new web3.eth.Contract(contractABI, contractAddress);
        const result = await contract.methods.isSuper(isSuperUser, isSuperTokenId).call();
        setIsSuperResult(result);
        console.log('IsSuper Result:', result);
      } catch (error) {
        console.error('Error calling isSuper function:', error);
      }
    }
  };

  const callIsSuperByAddressFunction = async () => {
    if (window.ethereum) {
      try {
        const web3 = new Web3(window.ethereum);
        const contract = new web3.eth.Contract(contractABI, contractAddress);
        const result = await contract.methods.isSuper(isSuperUser).call();
        setIsSuperResult(result);
        console.log('IsSuper Result (by address):', result);
      } catch (error) {
        console.error('Error calling isSuper function (by address):', error);
      }
    }
  };



  const callBalanceOfFunction = async () => {
    if (window.ethereum) {
      try {
        const web3 = new Web3(window.ethereum);
        const contract = new web3.eth.Contract(contractABI, contractAddress);
        const result = await contract.methods.balanceOf(balanceOfAccount, balanceOfId).call();
        setBalanceOfResult(result);
        console.log('BalanceOf Result:', result);
      } catch (error) {
        console.error('Error calling balanceOf function:', error);
      }
    }
  };

  const callTokenExistsFunction = async (tokenId) => {
    if (window.ethereum) {
      try {
        const web3 = new Web3(window.ethereum);
        const contract = new web3.eth.Contract(contractABI, contractAddress);
        const tokenExists = await contract.methods.exists(tokenId).call();
        setTokenExists(tokenExists);
        console.log('Token Exists:', tokenExists);
      } catch (error) {
        console.error('Error calling token exists function:', error);
      }
    }
  };





  const callTotalSupplyFunction = async (tokenId) => {
    if (window.ethereum) {
      try {
        const web3 = new Web3(window.ethereum);
        const contract = new web3.eth.Contract(contractABI, contractAddress);
        const totalSupply = await contract.methods.uri(tokenId).call();
        setTotalSupply(totalSupply);
        console.log('Total Supply:', totalSupply);
      } catch (error) {
        console.error('Error calling total supply function:', error);
      }
    }
  };


  const callUriFunction = async (tokenId) => {
    if (window.ethereum) {
      try {
        const web3 = new Web3(window.ethereum);
        const contract = new web3.eth.Contract(contractABI, contractAddress);
        const tokenURI = await contract.methods.uri(tokenId).call();
        setTokenURI(tokenURI);
        console.log('Token URI:', tokenURI);
      } catch (error) {
        console.error('Error calling uri function:', error);
      }
    }
  };



  return (
    <Container>
      <Typography variant="h4">SmartLaw Tokens on Polygon: Basic Explorer </Typography>
      <br/>
      <hr/>
      <br/>
      <Button variant="contained" color="primary" onClick={connectToMetamask}>
        Connect to MetaMask
      </Button>
      {isConnectedToPolygon ? (
    <Typography variant="h6" style={{ color: 'green' }}>
        Connected to Polygon
    </Typography>

    ) : (
    
    <Typography variant="h6" style={{ color: 'red' }}>
        Not connected to Polygon
    </Typography>
    )}
      <br />
      <hr/>
      <br />

      <Button variant="contained" color="primary" onClick={callSymbolFunction}>
        Call Symbol Function
      </Button>
      {/* Display Symbol Result */}
      {contractSymbol && (
        <Typography variant="h6">Symbol: {contractSymbol}</Typography>
      )}
      <br />
      <hr/>
      <br />

      <Button variant="contained" color="primary" onClick={callNameFunction}>
        Call Name Function
      </Button>
      {/* Display Name Result */}
      {contractName && (
        <Typography variant="h6">Name: {contractName}</Typography>
      )}
      <br />
      <hr/>
      <br />


      <Button variant="contained" color="primary" onClick={callTypeSupplyFunction}>
        BROKEN Call Type Supply Function - SEE CONSOLE returns number
      </Button>
      {/* Display Type Supply Result */}
      {typeSupply && (
        <Typography variant="h6">BROKEN Type Supply: {typeSupply} SEE CONSOLE returns number</Typography>
      )}
         
           
      
      <br />
      <hr/>
      <br />

      <Button variant="contained" color="primary" onClick={callOwnerFunction}>
        Call Owner Function
      </Button>
      <br />

      {/* Display Owner Result */}
      {contractOwner && (
        <Typography variant="h6">Smart Contract: {contractOwner}</Typography>
      )}
      <br />
      <hr/>
      <br />
      
      
      
      
      
      {/* Input fields for 'balanceOf' function */}
      <div>
        <input
          type="text"
          placeholder="Account Address"
          value={balanceOfAccount}
          onChange={(e) => setBalanceOfAccount(e.target.value)}
        />
        <input
          type="text"
          placeholder="Token ID"
          value={balanceOfId}
          onChange={(e) => setBalanceOfId(e.target.value)}
        />
      </div>

      <Button variant="contained" color="primary" onClick={callBalanceOfFunction}>
          BROKEN Call BalanceOf Function - SEE CONSOLE returns number
        </Button>

        <br />


      {/* Display BalanceOf Result */}
      {balanceOfResult !== null && (
        <Typography variant="h6">BalanceOf Result: {balanceOfResult}SEE CONSOLE returns number</Typography>
      )}

      <br />
      <hr/>
      <br />

      
      {/* Input fields for 'isSuper' function */}
      <div>
        <input
          type="text"
          placeholder="User Address"
          value={isSuperUser}
          onChange={(e) => setIsSuperUser(e.target.value)}
        />
        <input
          type="text"
          placeholder="Token ID"
          value={isSuperTokenId}
          onChange={(e) => setIsSuperTokenId(e.target.value)}
        />
      </div>

      <Button variant="contained" color="primary" onClick={callIsSuperFunction}>
        Call is Super Function
      </Button>
      <br />
     <br />
      <hr/>
      <br />


      {/* Button to call isSuper function by user address */}
      <div>
        <input
          type="text"
          placeholder="User Address"
          value={isSuperUser}
          onChange={(e) => setIsSuperUser(e.target.value)}
        />
        </div>

        <Button
          variant="contained"
          color="primary"
          onClick={callIsSuperByAddressFunction}
        >
          Call Is Super Function (by Address)
        </Button>
        <br />
      {/* Display IsSuper Result (by address) */}
      <div>
        
        {isSuperResult !== null && (
        <Typography variant="h6">
          IsSuper Result (by address): {isSuperResult ? 'Yes' : 'No'}
        </Typography>
      )}

      <br />
      <hr/>
      <br />

      {/* Input field for 'uri' function */}
      <div>


      <input
        type="text"
        placeholder="Enter Token ID"
        id="tokenId"
      />
      </div>
      <Button
        variant="contained"
        color="primary"
        onClick={() => callTokenExistsFunction(document.getElementById('tokenId').value)}>
        Call Token Total Supply by Token ID
      </Button>

      </div>

      <br />
      <hr/>
      <br />


      {/* Input field for 'uri' function */}
      <div>
      <input
        type="text"
        placeholder="Enter Token ID"
        id="tokenId"
        />
        </div>
      <Button
        variant="contained"
        color="primary"
        onClick={() => callTokenExistsFunction(document.getElementById('tokenId').value)}>
        Call Token Exists Function by Token ID
      </Button>
      <br />
      <br />
      <hr/>
      <br />



      {/* Input field for 'uri' function */}
      <div>
      <input
        type="text"
        placeholder="Enter Token ID"
        id="tokenId"
      />
        </div>
      <Button
        variant="contained"
        color="primary"
        onClick={() => callTotalSupplyFunction(document.getElementById('tokenId').value)}>
        Call Total Supply
      </Button>
      <br />
      <br />
      <hr/>
      <br />



      {/* Input field for 'uri' function */}
      <div>
      <input
        type="text"
        placeholder="Enter Token ID"
        id="tokenId"
        />
        </div>
      <Button
        variant="contained"
        color="primary"
        onClick={() => callUriFunction(document.getElementById('tokenId').value)}>
        Call URI Function by Token ID
      </Button>


      <br />
      <hr/>
      <br />


      <hr />

      {contractSymbol && (
        <Typography variant="h6">Symbol: {contractSymbol}</Typography>
      )}
      {contractName && (
        <Typography variant="h6">Name: {contractName}</Typography>
      )}
      {typeSupply && (
        <Typography variant="h6">Type Supply: {typeSupply}</Typography>
      )}
      {contractOwner && (
        <Typography variant="h6">Smart Contract: {contractOwner}</Typography>
      )}
      <hr/>
      {balanceOfResult !== null && (
        <Typography align="left" variant="h6">BalanceOf Result: {balanceOfResult}</Typography>
      )}
      {isSuperResult !== null && (
        <Typography align="left" variant="h6">IsSuper Result: {isSuperResult ? 'Yes' : 'No'}</Typography>
      )}
      {tokenExists && (
        <Typography align="left" variant="h6">Token Exists: {tokenExists? 'Yes' : 'No'}</Typography>
      )}
      {totalSupply && (
        <Typography align="left" variant="h6">Token Supply: {totalSupply}</Typography>
      )}
      {tokenURI && (
        <Typography align="left" variant="h6">Token URI: {tokenURI}</Typography>
      )}


<br />
<hr/>
<br />

<Typography align="left" variant="body1">
<p>0x00a2Ddfa736214563CEa9AEf5100f2e90c402918 : Regency</p> 
<p>0x130093A5aEbc07e78e16f0EcEF09d1c45AfD8178 : WorldLaw</p>
<p>0x00c69A89F6Bdbb8af93745C80A99ED23344F5261 : Wardens</p>
<p>0x5FFE2A6f49c4D0b76166624b8bfd91AA179AA3FD : SmartLaw</p>
<p>0x7B035331967075a168471DfBD23eD977f048f61E : Tenfinney</p>
<p>0x71f9A84813e6a5485FEAf9543577B7E8F6DcE768 : Fortunado</p>
</Typography>

<hr/>


<h4>roleToken GET20 - Integer for Role 0-12</h4>

<Typography align="left" variant="body1">
<p>30022400 WorldLaw Wardens Smartlaw - Owned by Wardens</p>
<p>Create SuperUser Role Token : 55647014917665617451179885828051456437304168409650150386777920530022400</p> 

<p/>Role Token 0 : 55213970774324510299478046898216203619608871777363092441300193790394368 : What is this one?<p/>
<p/>Role Token 1 : 55647014917665617451179885828051456437304168409650150386777920530022400 : Superuser Index2<p/>
<p/>Role Token 2 : 55217340767657904129452380275102081073443076420415910012860331741675520<p/>
<p/>Role Token 3 : 55219025764324601044439546963545019800360178741942318798640400717316096<p/>
<p/>Role Token 4 : 55220710760991297959426713651987958527277281063468727584420469692956672<p/>
<p/>Role Token 5 : 55222395757657994874413880340430897254194383384995136370200538668597248<p/>
<p/>Role Token 6 : 55224080754324691789401047028873835981111485706521545155980607644237824<p/>
<p/>Role Token 7 : 55225765750991388704388213717316774708028588028047953941760676619878400<p/>
<p/>Role Token 8 : 55227450747658085619375380405759713434945690349574362727540745595518976<p/>
<p/>Role Token 9 : 55229135744324782534362547094202652161862792671100771513320814571159552<p/>
<p/>Role Token 10: 55230820740991479449349713782645590888779894992627180299100883546800128<p/>
<p/>Role Token 11: 55232505737658176364336880471088529615696997314153589084880952522440704<p/>
<p/>Role Token 12: 55234190734324873279324047159531468342614099635679997870661021498081280<p/>
<p/>roleToken with index increments the token above, roleToken uint8 + index uint256 <p/>
<p/>for example: token 1 index 0 = 55647014917665617451179885828051456437304168409650150386777920530022400 same as above <p/>
<p/>for example: token 1 index 1 = 55647014917665617451179885828051456437304168409650150386777920530022401 same as above <p/>

<hr/>

<h2>Role Tokens in Bytes32</h2>
<h2>Tokens by Index use as the input to GET25 tokenIndex Only Superuser Queries - USE this or the bytes32</h2>
<p/>Role Token 0 : 0x80000000000000000000000000000000000000000000000000000000000<p/>
<p/>Role Token 1 : 0x81010000000000000000000000000000000000000000000000000000000 : Superuser<p/>
<p/>Role Token 2 : 0x80020000000000000000000000000000000000000000000000000000000<p/>
<p/>Role Token 3 : 0x80030000000000000000000000000000000000000000000000000000000<p/>
<p/>Role Token 4 : 0x80040000000000000000000000000000000000000000000000000000000<p/>
<p/>Role Token 5 : 0x80050000000000000000000000000000000000000000000000000000000<p/>
<p/>Role Token 6 : 0x80060000000000000000000000000000000000000000000000000000000<p/>
<p/>Role Token 7 : 0x80070000000000000000000000000000000000000000000000000000000<p/>
<p/>Role Token 8 : 0x80080000000000000000000000000000000000000000000000000000000<p/>
<p/>Role Token 9 : 0x80090000000000000000000000000000000000000000000000000000000<p/>
<p/>Role Token 10: 0x800a0000000000000000000000000000000000000000000000000000000<p/>
<p/>Role Token 11: 0x800b0000000000000000000000000000000000000000000000000000000<p/>
<p/>Role Token 12: 0x800c0000000000000000000000000000000000000000000000000000000<p/>


<hr/>

<p/>Role Token 0 : 55213970774324510299478046898216203619608871777363092441300193790394368 : 0x80000000000000000000000000000000000000000000000000000000000 : GATING-UNUSED<p/>
<p/>Role Token 1 : 55647014917665617451179885828051456437304168409650150386777920530022400 : 0x81010000000000000000000000000000000000000000000000000000000 : Superuser<p/>
<p/>Role Token 2 : 55217340767657904129452380275102081073443076420415910012860331741675520 : 0x80020000000000000000000000000000000000000000000000000000000 : Minter<p/>
<p/>Role Token 3 : 55219025764324601044439546963545019800360178741942318798640400717316096 : 0x80030000000000000000000000000000000000000000000000000000000 : Caster<p/>
<p/>Role Token 4 : 55220710760991297959426713651987958527277281063468727584420469692956672 : 0x80040000000000000000000000000000000000000000000000000000000 : Transferer<p/>
<p/>Role Token 5 : 55222395757657994874413880340430897254194383384995136370200538668597248 : 0x80050000000000000000000000000000000000000000000000000000000 : Configurer<p/>
<p/>Role Token 6 : 55224080754324691789401047028873835981111485706521545155980607644237824 : 0x80060000000000000000000000000000000000000000000000000000000 : Maintainer<p/>
<p/>Role Token 7 : 55225765750991388704388213717316774708028588028047953941760676619878400 : 0x80070000000000000000000000000000000000000000000000000000000 : Creator<p/>
<p/>Role Token 8 : 55227450747658085619375380405759713434945690349574362727540745595518976 : 0x80080000000000000000000000000000000000000000000000000000000 : Limiter<p/>
<p/>Role Token 9 : 55229135744324782534362547094202652161862792671100771513320814571159552 : 0x80090000000000000000000000000000000000000000000000000000000 : Burner<p/>
<p/>Role Token 10: 55230820740991479449349713782645590888779894992627180299100883546800128 : 0x800a0000000000000000000000000000000000000000000000000000000 : Destroyer<p/>
<p/>Role Token 11: 55232505737658176364336880471088529615696997314153589084880952522440704 : 0x800b0000000000000000000000000000000000000000000000000000000 : Oracle<p/>
<p/>Role Token 12: 55234190734324873279324047159531468342614099635679997870661021498081280 : 0x800c0000000000000000000000000000000000000000000000000000000 : ReservedLast<p/>


<p/>Superuser<p/>
<p/>Minter<p/>
<p/>Caster<p/>
<p/>Transferer<p/>
<p/>Configurer<p/>
<p/>Maintainer<p/>
<p/>Creator<p/>
<p/>Limiter<p/>
<p/>Burner<p/>
<p/>Destroyer<p/>
<p/>Oracle<p/>
<p/>ReservedLast<p/>

</Typography>



<h4>roleToken GET21 - Integer for Role 0-12 + index number - increments no larger than 99999999</h4>
<p/>roleToken with index increments the token above, roleToken uint8 + index uint256 <p/>
<p/>for example: token 1 index 0 = 55647014917665617451179885828051456437304168409650150386777920530022400 same as above <p/>
<p/>for example: token 1 index 1 = 55647014917665617451179885828051456437304168409650150386777920530022401 same as above <p/>




<h3>https://neptunemutual.com/web3-tools/number-to-bytes32-converter/</h3>
<hr/>
<Typography align="left" variant="body1">
<p>Create Token1 : 55647857415998965908673469172272925800762719570413354779667955017842690 : 17842690 Owned by Wardens</p>
<p>Create Token2 : 55647857415998965908673469172272925800762719570413354779667955017842692 : 17842692 Owned by SmartLaw</p>
<p>Create Token3 : 55647857415998965908673469172272925800762719570413354779667955017842694 : 17842694 Owned by WorldLaw</p>
<p>Create Token4 : 55647857415998965908673469172272925800762719570413354779667955017842696 : 17842696 Owned by WorldLaw</p>
<p>Create Token5 : 55647857415998965908673469172272925800762719570413354779667955017842698 : 17842698 Owned by WorldLaw</p>
<p>Create Token7 : 55647857415998965908673469172272925800762719570413354779667955017842700 : 17842700 Owned by WorldLaw</p>
<p>Create Token8 : 55647857415998965908673469172272925800762719570413354779667955017842702 : 17842702 Owned by WorldLaw</p>
<p>Create Token9 : 55647857415998965908673469172272925800762719570413354779667955017842704 : 17842704 Owned by WorldLaw</p>
<p>Create Token10: 55647857415998965908673469172272925800762719570413354779667955017842706 : 17842706 Owned by WorldLaw</p>
<hr/>
</Typography>

<hr/>

<h3>https://neptunemutual.com/web3-tools/number-to-bytes32-converter/</h3>
<hr/>
<Typography align="left" variant="body1">
<p>Create Token1 : 0x81018000000000000000000000000000000000000000000000000000002 : 17842690 Owned by Wardens</p>
<p>Create Token2 : 0x81018000000000000000000000000000000000000000000000000000004 : 17842692 Owned by SmartLaw</p>
<p>Create Token3 : 0x81018000000000000000000000000000000000000000000000000000006 : 17842694 Owned by WorldLaw</p>
<p>Create Token4 : 0x81018000000000000000000000000000000000000000000000000000008 : 17842696 Owned by WorldLaw</p>
<p>Create Token5 : 0x8101800000000000000000000000000000000000000000000000000000a : 17842698 Owned by WorldLaw</p>
<p>Create Token7 : 0x8101800000000000000000000000000000000000000000000000000000c : 17842700 Owned by WorldLaw</p>
<p>Create Token8 : 0x8101800000000000000000000000000000000000000000000000000000e : 17842702 Owned by WorldLaw</p>
<p>Create Token9 : 0x81018000000000000000000000000000000000000000000000000000010 : 17842704 Owned by WorldLaw</p>
<p>Create Token10: 0x81018000000000000000000000000000000000000000000000000000012 : 17842706 Owned by WorldLaw</p>
<hr/>
</Typography>

<hr/>


<h2>Tokens by Index tokenByIndex GET24 Use integers 1... No Zero Index  </h2>
<h2>TokenIndex tokenIndex GET25 Use Tokens Below  </h2>


<Typography align="left" variant="body1">

<p>Created Token 1 :  55647014917665617451179885828051456437304168409650150386777920530022400 : Token Index 2</p>
<p>Created Token 2 : 496925736968920592695302422083945832576479845996267831971701744113549314 : Token Index 2</p>
<p>Created Token 3 :  55647857415998965908673469172272925800762719570413354779667955017842690 : Token Index 4</p>
<p>Created Token 4 : 496925736968920592695302422083945832576479845996267831971701744113549316 : Token Index 4</p>
<p>Created Token 5 :  55647857415998965908673469172272925800762719570413354779667955017842692 : Token Index 6</p>
<p>Created Token 6 : 496925736968920592695302422083945832576479845996267831971701744113549318 : Token Index 6</p>
<p>Created Token 7 :  55647857415998965908673469172272925800762719570413354779667955017842694 : Token Index 8</p>
<p>Created Token 8 : 496925736968920592695302422083945832576479845996267831971701744113549320 : Token Index 8</p>
<p>Created Token 9 :  55647857415998965908673469172272925800762719570413354779667955017842696 : Token Index 10</p>
<p>Created Token 10: 496925736968920592695302422083945832576479845996267831971701744113549322 : Token Index 10</p>
<p>Created Token 11:  55647857415998965908673469172272925800762719570413354779667955017842698 : Token Index 12</p>
<p>Created Token 12: 496925736968920592695302422083945832576479845996267831971701744113549324 : Token Index 12</p>
<p>Created Token 13:  55647857415998965908673469172272925800762719570413354779667955017842700 : Token Index 14</p>
<p>Created Token 14: 496925736968920592695302422083945832576479845996267831971701744113549326 : Token Index 14</p>
<p>Created Token 15:  55647857415998965908673469172272925800762719570413354779667955017842702 : Token Index 16</p>
<p>Created Token 16: 496925736968920592695302422083945832576479845996267831971701744113549328 : Token Index 16</p>
<p>Created Token 17:  55647857415998965908673469172272925800762719570413354779667955017842704 : Token Index 18</p>
<p>Created Token 18: 496925736968920592695302422083945832576479845996267831971701744113549330 : Token Index 18</p>
<p>Created Token 19:  55647857415998965908673469172272925800762719570413354779667955017842706 : Token Index 20</p>
<hr/>
</Typography>


<h3>https://neptunemutual.com/web3-tools/number-to-bytes32-converter/</h3>
<h2>Tokens by Index tokenByIndex GET24 Use integers 1... No Zero Index  </h2>
<Typography align="left" variant="body1">
<p>Created Token 1 :  0x81010000000000000000000000000000000000000000000000000000000 : 30022400 </p>
<p>Created Token 2 : 0x480000000000000000000000000000000000000000000000000000000002 : 13549314</p>
<p>Created Token 3 :  0x81018000000000000000000000000000000000000000000000000000002 : 17842690</p>
<p>Created Token 4 : 0x480000000000000000000000000000000000000000000000000000000004 : 13549316</p>
<p>Created Token 5 :  0x81018000000000000000000000000000000000000000000000000000004 : 17842692</p>
<p>Created Token 6 : 0x480000000000000000000000000000000000000000000000000000000006 : 13549318</p>
<p>Created Token 7 :  0x81018000000000000000000000000000000000000000000000000000006 : 17842694</p>
<p>Created Token 8 : 0x480000000000000000000000000000000000000000000000000000000008 : 13549320</p>
<p>Created Token 9 :  0x81018000000000000000000000000000000000000000000000000000008 : 17842696</p>
<p>Created Token 10: 0x48000000000000000000000000000000000000000000000000000000000a : 13549322</p>
<p>Created Token 11:  0x8101800000000000000000000000000000000000000000000000000000a : 17842698</p>
<p>Created Token 12: 0x48000000000000000000000000000000000000000000000000000000000c : 13549324</p>
<p>Created Token 13:  0x8101800000000000000000000000000000000000000000000000000000c : 17842700</p>
<p>Created Token 14: 0x48000000000000000000000000000000000000000000000000000000000e : 13549326</p>
<p>Created Token 15:  0x8101800000000000000000000000000000000000000000000000000000e : 17842702</p>
<p>Created Token 16: 0x480000000000000000000000000000000000000000000000000000000010 : 13549328</p>
<p>Created Token 17:  0x81018000000000000000000000000000000000000000000000000000010 : 17842704</p>
<p>Created Token 18: 0x480000000000000000000000000000000000000000000000000000000012 : 13549330</p>
<p>Created Token 19:  0x81018000000000000000000000000000000000000000000000000000012 : 17842706</p>
<hr/>
</Typography>


      
<h2>Tokens by Index tokenOfOwnerByIndex GET26 : 0x130093A5aEbc07e78e16f0EcEF09d1c45AfD8178 use Web3 Address and index position 0 is the superuser  </h2>
<Typography align="left" variant="body1">

<p>WorldLaw Index 0 :  55647014917665617451179885828051456437304168409650150386777920530022400</p>
<p>WorldLaw Index 1 :  55647857415998965908673469172272925800762719570413354779667955017842694</p>
<p>WorldLaw Index 2 : 496925736968920592695302422083945832576479845996267831971701744113549318</p>
<p>WorldLaw Index 3 :  55647857415998965908673469172272925800762719570413354779667955017842696</p>
<p>WorldLaw Index 4 :  55647857415998965908673469172272925800762719570413354779667955017842698</p>
<p>WorldLaw Index 5 :  55647857415998965908673469172272925800762719570413354779667955017842700</p>
<p>WorldLaw Index 6 :  55647857415998965908673469172272925800762719570413354779667955017842702</p>
<p>WorldLaw Index 7 :  55647857415998965908673469172272925800762719570413354779667955017842704</p>
<p>WorldLaw Index 8 :  55647857415998965908673469172272925800762719570413354779667955017842706</p>
<p>WorldLaw Index 9 : 496925736968920592695302422083945832576479845996267831971701744113549314</p>
<p>WorldLaw Index 10: 496925736968920592695302422083945832576479845996267831971701744113549316</p>
<p>WorldLaw Index 11: 496925736968920592695302422083945832576479845996267831971701744113549322</p>
<p>WorldLaw Index 12: 496925736968920592695302422083945832576479845996267831971701744113549324</p>
<p>WorldLaw Index 13: 496925736968920592695302422083945832576479845996267831971701744113549326</p>
<p>WorldLaw Index 14: 496925736968920592695302422083945832576479845996267831971701744113549328</p>
<p>WorldLaw Index 15: 496925736968920592695302422083945832576479845996267831971701744113549330</p>
<hr/>
</Typography>


<h2>Tokens by Index tokenOfOwnerByIndex GET26 : 0x7B035331967075a168471DfBD23eD977f048f61E use Web3 Address and index position 0 is the superuser  </h2>
<Typography align="left" variant="body1">

<p>Tenfinney Index 0 : 496925736968920592695302422083945832576479845996267831971701744113549316</p>
<p>Tenfinney Index 1 : 496925736968920592695302422083945832576479845996267831971701744113549320</p>
<p>Tenfinney Index 2 : 496925736968920592695302422083945832576479845996267831971701744113549322</p>
<p>Tenfinney Index 3 : 496925736968920592695302422083945832576479845996267831971701744113549324</p>
<p>Tenfinney Index 4 : 496925736968920592695302422083945832576479845996267831971701744113549326</p>
<p>Tenfinney Index 5 : 496925736968920592695302422083945832576479845996267831971701744113549328</p>
<p>Tenfinney Index 6 : 496925736968920592695302422083945832576479845996267831971701744113549330</p>
<hr/>
</Typography>


<h2>Tokens by Index tokenOfOwnerByIndex GET26 : 0x00a2Ddfa736214563CEa9AEf5100f2e90c402918 use Web3 Address and index position 0 is the superuser  </h2>
<Typography align="left" variant="body1">

<p>Regency Index 0 : 496925736968920592695302422083945832576479845996267831971701744113549316</p>

<hr/>
</Typography>

<h2>Tokens by Index tokenOfOwnerByIndex GET26 : 0x00c69A89F6Bdbb8af93745C80A99ED23344F5261 use Web3 Address and index position 0 is the superuser  </h2>
<Typography align="left" variant="body1">

<p>Wardens Index 0 : 55647014917665617451179885828051456437304168409650150386777920530022400</p>
<p>Wardens Index 1 : 55647857415998965908673469172272925800762719570413354779667955017842690</p>
<hr/>
</Typography>



<h2>Tokens by Index tokenOfOwnerByIndex GET26 : 0x5FFE2A6f49c4D0b76166624b8bfd91AA179AA3FD use Web3 Address and index position 0 is the superuser  </h2>
<Typography align="left" variant="body1">

<p>SmartLaw Index 0 :  55647014917665617451179885828051456437304168409650150386777920530022400</p>
<p>SmartLaw Index 1 :  55647857415998965908673469172272925800762719570413354779667955017842692</p>
<p>SmartLaw Index 2 : 496925736968920592695302422083945832576479845996267831971701744113549314</p>
<hr/>
</Typography>


<h2>Tokens by Index tokenOfOwnerByIndex GET26 : 0x71f9A84813e6a5485FEAf9543577B7E8F6DcE768 use Web3 Address and index position 0 is the superuser  </h2>
<Typography align="left" variant="body1">

<p>Fortunado Index 0 : 496925736968920592695302422083945832576479845996267831971701744113549320</p>
<p>Fortunado Index 1 : 496925736968920592695302422083945832576479845996267831971701744113549326</p>
<p>Fortunado Index 2 : 496925736968920592695302422083945832576479845996267831971701744113549328</p>
<hr/>
</Typography>

<hr/>
<h4>hasRole GET7 - What goes in here????????</h4>

<hr/>
<h4>hasRole GET8 - Integer for Role + Web3 Address + any integer and the return is the same. Becasue it's a Superuser?</h4>

<hr/>
<h4>hasRole GET9 - Integer for Role + Web3 Address</h4>

<hr/>
<h4>hasRole GET10 - Integer for Role + Web3 Address</h4>

<hr/>
<h4>intValues GET11 - What goes in here????????</h4>

<hr/>
<h4>isApprovedForAll GET12 - What goes in here????????</h4>

<hr/>
<h4>isSuper GET13 - Web3Address</h4>

<hr/>
<h4>isSuper GET14 - Web3Address + Any integer or token Must be for SuperUser?</h4>

<hr/>
<h4>isSuper GET15 - Web3Address + Any integer or token Must be for SuperUser?</h4>

<hr/>
<h4>isSuper GET16 - What is this? Why is it false?</h4>

<hr/>
<h4>supportsInterface GET22 - What is this? where do I fing the Interface?</h4>


<hr/>
<h4>totalSupply GET27 - Add the Token like 496925736968920592695302422083945832576479845996267831971701744113549326</h4>

<hr/>
<h4>totalSupply GET29 - uintValues What is this? input uint256</h4>


<hr/>
<h4>uri GET30 - Add the Token like 496925736968920592695302422083945832576479845996267831971701744113549326</h4>





<Typography align="left" variant="body1">
<p>Mint: 496925736968920592695302422083945832576479845996267831971701744113549314 : 2 owners WorldLaw SmartLaw : Starter Legaltech Digital Artifact</p>
<p>Mint: 496925736968920592695302422083945832576479845996267831971701744113549316 : 3 owners WorldLaw Tenfinney Regency : Web3 Legal Engineering - Web3Skills SmartLaw</p>
<p>Mint: 496925736968920592695302422083945832576479845996267831971701744113549318 : 2 owners WorldLaw x2 : LexAutomatico</p>
<p>Mint Token: 496925736968920592695302422083945832576479845996267831971701744113549320 : 6 owners LexDAO : LexDAO 2022-2023 Participation</p>
<p>Mint: 496925736968920592695302422083945832576479845996267831971701744113549322 : 2 owners WorldLaw Tenfinney : California MCLE-101 Introduction to Web3</p>
<p>Mint: 496925736968920592695302422083945832576479845996267831971701744113549324 : 2 owners WorldLaw Tenfinney : CLEC-101 - Introduction to Web3 - How Web3 will Change the Legal Industry</p>
<p>Mint Token: 496925736968920592695302422083945832576479845996267831971701744113549326 : 23 owners LexDAO : CLE Course Content Access Token</p>
<p>Mint: 496925736968920592695302422083945832576479845996267831971701744113549328 : 3 owners Sero Tenfinney WorldLaw : MCLE Course Content Access Token</p>
<p>Mint: 496925736968920592695302422083945832576479845996267831971701744113549330 : 2 owners WorldLaw Tenfinney : California MCLE-101 Certificate of Completion</p>
<p>Mint: </p>
</Typography>

    </Container>
  );
}

export default SmartContractUI;
